// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ShZ3XKzJvug5LVgy_BVm > div > div:nth-of-type(2) {\n  padding-left: 5px;\n}\n.gACF2MPhTRYt1nuls_2Y {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://./src/components/FindWithSelect/style.module.less"],"names":[],"mappings":"AAAA;EAEI,iBAAA;AAAJ;AAGA;EACE,aAAA;AADF","sourcesContent":[".asyncSelect{\n  >div>div:nth-of-type(2){\n    padding-left: 5px;\n  }\n}\n.indicatorSeparator{\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"asyncSelect": "ShZ3XKzJvug5LVgy_BVm",
	"indicatorSeparator": "gACF2MPhTRYt1nuls_2Y"
};
export default ___CSS_LOADER_EXPORT___;
